import React from 'react';

import Image from '../../library/image/image';

import './group-affiliation-promotion-id-me-button.scss';

interface GroupAffiliationPromotionIdMeButtonProps {
  height?: string;
  isAppliedPromotion?: boolean;
  openVerificationWindow?: () => void;
  width?: string;
}

function GroupAffiliationPromotionIdMeButton(
  props: GroupAffiliationPromotionIdMeButtonProps
) {
  const { height, isAppliedPromotion, openVerificationWindow, width } = props;

  return (
    <>
      {!isAppliedPromotion && (
        <button
          className="group-affiliation-promotion-id-me-button"
          onClick={openVerificationWindow}
        >
          <Image
            alt="ID.me Logo"
            height={height ?? '40'}
            loading="lazy"
            src="/images/idme-button.svg"
            styleName="logo"
            width={width ?? '218'}
          />
        </button>
      )}
    </>
  );
}

export default GroupAffiliationPromotionIdMeButton;
